import {
    DrawerStack,
    SectionHeading,
    TikTokDrawerTimeSeriesWrapper,
} from './styledComponents';
import { HealthStatMeter, Metric, MetricLabel } from 'components/HealthStats';
import DimensionIcon from 'components/DimensionIcon';
import DrawerHeader from 'components/DrawerHeader';
import DownloadTimeSeriesButton from 'components/Button/DownloadTimeSeriesButton';
import { FiExternalLink } from 'react-icons/fi';
import { IconButton } from 'components/Button';
import Stack from 'components/Stack';
import TikTokTimeSeriesDrawerLogo from '../TikTokTimeSeriesDrawerLogo';
import TopHashtagsLogo from '../TopHashtagsLogo';
import TopPostsLogo from '../TopPostsLogo';
import { UpgradeToSpateProLink } from 'components/NoAccessMessage';
import { tooltips } from '@/copy';

function TikTokDrawerContentStarter({ dataPoint, paginateBy }) {
    const paginateType = paginateBy === 'brands' ? 'brand' : 'category';
    const { name } = dataPoint;

    return (
        <Stack $space="1.5rem" css="padding: 1.5rem 0 7rem 0;">
            <DrawerHeader
                name={name}
                eyebrow={
                    <>
                        <DimensionIcon dimensionType={paginateType} />
                        {paginateType}
                    </>
                }
            />
            <DrawerStack css="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem;">
                {Object.entries(dataPoint.healthStats || {})
                    .filter(([metricLabel]) =>
                        ['average weekly views'].includes(metricLabel),
                    )
                    .map(([metricLabel, { score, scoreLabel, metric }]) => (
                        <Stack $space=".5rem" key={metricLabel}>
                            <HealthStatMeter
                                score={score}
                                scoreLabel={scoreLabel}
                                metricLabel={metricLabel}
                            />
                            <Stack $space=".5rem">
                                <Metric>{metric}</Metric>
                                {tooltips.healthStats[metricLabel]
                                    .abbrTitleHTML ? (
                                    <MetricLabel
                                        dangerouslySetInnerHTML={{
                                            __html: tooltips.healthStats[
                                                metricLabel
                                            ].abbrTitleHTML,
                                        }}
                                    />
                                ) : (
                                    <MetricLabel>{metricLabel}</MetricLabel>
                                )}
                            </Stack>
                        </Stack>
                    ))}
            </DrawerStack>
            <DrawerStack $direction="row" $space="15px" css="display: flex;">
                <DownloadTimeSeriesButton
                    data={null}
                    css="font-size: 1rem; flex-shrink: 0;"
                />
                <IconButton
                    intent="primary"
                    size="sm"
                    IconRight={FiExternalLink}
                    style={{ flexGrow: 1 }}
                    isDisabled={true}
                >
                    See more data
                </IconButton>
            </DrawerStack>
            <TikTokDrawerTimeSeriesWrapper>
                <Stack
                    $direction="column"
                    $space="1.5rem"
                    css="display: flex; flex-direction: column; align-items: center; padding: 3.25rem 0;"
                >
                    <TikTokTimeSeriesDrawerLogo />
                    <span css="text-align: center;">
                        View trend performance across <br />
                        TikTok and Search.
                    </span>
                    <UpgradeToSpateProLink />
                </Stack>
            </TikTokDrawerTimeSeriesWrapper>
            <DrawerStack>
                <SectionHeading>
                    <span css="display: flex; align-items: center;">
                        Hashtags
                    </span>
                </SectionHeading>
                <div
                    css={`
                        padding: 1rem;
                        display: flex;
                        gap: 0.5rem;
                        justify-content: flex-start;
                        align-items: center;
                        background-color: ${({ theme }) => theme.gray_50};
                    `}
                >
                    <TopHashtagsLogo />
                    <span>
                        Explore the Top Hashtags that are leading the trend.
                    </span>
                </div>
            </DrawerStack>
            <DrawerStack>
                <SectionHeading>
                    <span css="display: flex; align-items: center;">
                        Top Posts
                    </span>
                </SectionHeading>
                <Stack
                    $direction="column"
                    $space="1.5rem"
                    css={`
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding: 3.25rem 0;
                        background-color: ${({ theme }) => theme.gray_50};
                    `}
                >
                    <TopPostsLogo />
                    <img
                        src="https://storage.googleapis.com/spate-186619/images/app/top-posts-preview.png"
                        width="306"
                        height="173"
                    />
                    <span>
                        Explore top posts with Spate Pro.
                        <br />
                        What are consumers watching?
                    </span>
                    <UpgradeToSpateProLink />
                </Stack>
            </DrawerStack>
        </Stack>
    );
}

export default TikTokDrawerContentStarter;
